import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { TaskService } from '../../services/task.service';
import { CondominiumService } from '../../services/condominium.service';

@Component({
    selector: 'app-tasks-summary',
    templateUrl: './tasks-summary.component.html',
    styleUrls: ['./tasks-summary.component.sass'],
    standalone: false
})
export class TasksSummaryComponent implements OnInit {
  tasks: any[] = [];
  isLoading = true;
  condominiumId: number | null = null;

  constructor(
    private taskService: TaskService,
    private condominiumService: CondominiumService,
    private router: Router,
    private route: ActivatedRoute
  ) { }

  ngOnInit(): void {
    this.route.parent?.url.subscribe(url => {
      let found = false;
      if (url[0].path === 'condominium' && url.length > 1) {
        this.condominiumId = +url[1];
        this.loadTasks();
        found = true;
      }
      if (!found) {
        this.router.navigate(['/condominiums']);
      }
    });
  }

  loadTasks(): void {
    if (!this.condominiumId) {
      this.isLoading = false;
      return;
    }

    this.isLoading = true;
    this.taskService.getTasks(this.condominiumId, 0, 5).subscribe({
      next: (response) => {
        this.tasks = response._embedded?.taskResponseDTOList || [];
        this.isLoading = false;
      },
      error: (error) => {
        console.error('Error loading tasks:', error);
        this.isLoading = false;
      }
    });
  }

  navigateToTask(id: number): void {
    if (this.condominiumId) {
      this.router.navigate([`/condominium/${this.condominiumId}/task`, id]);
    }
  }

  navigateToAllTasks(): void {
    if (this.condominiumId) {
      this.router.navigate([`/condominium/${this.condominiumId}/tasks`]);
    }
  }

  navigateToCreateTask(): void {
    if (this.condominiumId) {
      this.router.navigate([`/condominium/${this.condominiumId}/task/create`]);
    }
  }
}
